import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

import { UserdropDown } from "../components";
import { ClientsList } from "../api/api";
//import { useCookies } from "react-cookie";

const Topnav = (onToggle: any) => {
  const [clientsList, setClientsList] = useState([]);
  const [selectedClients, setSelectedClients] = useState<any>('');
  const selectedClient: any = Cookies.get("client");
  const navigate = useNavigate();
  function onClick(e: any) {
    Cookies.remove("newJwt",  { path: "/" });
    Cookies.remove("client");
    Cookies.remove("roles");
    Cookies.remove("sessionId");
    Cookies.remove("firstName");
    Cookies.remove("id");
    Cookies.remove("lastName");
    navigate("/");
  }

  useEffect(() => {
    ClientsList(Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setClientsList(response);
      });
  }, []);
  useEffect(() => {
    const clientIdToFilter = parseInt(selectedClient); // Specify the clientID you want to filter
    const filteredData = clientsList?.filter((item:any) => item.clientID === clientIdToFilter);
    setSelectedClients(filteredData)
  }, [clientsList])
  
  return (
    <nav className="navbar navbar-expand navbar-theme">
      <div className="navbar-collapse collapse">
      
        <ul className="navbar-nav ms-auto">
          <li className="text-white pt-3 mt-2">
          {selectedClients && selectedClients?.map((e:any) =>{
            return e.clientName
          })}
          </li>
          <li>
            <UserdropDown onClick={onClick} />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export { Topnav };
